import { AbstractModel } from '@patsnap/tahiti-core';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { OarStatementContentModel } from '../oar-statement-content-model';
import type { OarStatementContent } from '../../types/oar-statement-types';

/**
 * 创建初始的 OAR 陈述书内容数据
 *
 * @returns 初始化的 OarStatementContent 对象
 */
function createInitialOarStatementContent(): OarStatementContent {
    return {
        taskId: '',
        statementContent: undefined,
        statementGeneratedAt: undefined,
        statementWordCount: undefined,
        claimComparisonContent: undefined,
        claimComparisonGeneratedAt: undefined,
        claimComparisonWordCount: undefined,
        descriptionComparisonContent: undefined,
        descriptionComparisonGeneratedAt: undefined,
        descriptionComparisonWordCount: undefined,
    };
}

/**
 * OAR 陈述书内容模型实现
 *
 * 管理 OAR 任务中陈述书和对照页的内容数据，包括：
 * - 陈述书正文内容
 * - 权利要求对照页内容
 * - 说明书对照页内容
 * - 生成时间戳和统计信息
 */
@injectable()
export class OarStatementContentModelImpl
    extends AbstractModel<OarStatementContent>
    implements OarStatementContentModel
{
    protected _modelData: OarStatementContent = createInitialOarStatementContent();

    /**
     * 更新模型数据
     *
     * @param updater - 更新函数
     */
    override update(updater: (data: OarStatementContent) => OarStatementContent): void {
        super.update(updater);
    }

    /**
     * 克隆数据
     *
     * @param data - 要克隆的数据
     * @returns 克隆后的数据
     */
    clone(data: OarStatementContent): OarStatementContent {
        return {
            ...data,
        };
    }

    /**
     * 释放资源
     *
     * 清空所有陈述书和对照页内容数据，恢复到初始状态
     */
    dispose(): void {
        this.update(() => createInitialOarStatementContent());
    }
}
